module.exports = __webpack_public_path__ + "img/bewohner-aktiv.39807462.svg";